import classNames from 'classnames'
import { FieldValues, UseFormRegister } from 'react-hook-form'

import { FieldLabel } from '@/Atomic/Atoms/FieldLabel'
import { Icon } from '@/Atomic/Atoms/Icon'
import { BasicInput, BasicInputProps } from '@/Atomic/Atoms/Inputs/BasicInput'

import '../FieldStates.scss'
import './Input.scss'

interface InputProps extends BasicInputProps {
  name: string
  label?: string
  requirementState?: 'required' | 'optional'
  register?: UseFormRegister<FieldValues>
  className?: string
  inputClassName?: string
  error?: string
}

export const Input: React.FC<InputProps> = ({
  name,
  label,
  requirementState,
  defaultValue,
  register,
  className,
  disabled,
  inputClassName,
  error,
  ...props
}) => {
  return (
    <div
      className={classNames(className, {
        'field--readonly': disabled,
        'field-invalid': error,
      })}
    >
      <FieldLabel
        name={name}
        label={label}
        requirementState={requirementState}
      />
      <BasicInput
        name={name}
        register={register}
        disabled={disabled}
        className={inputClassName}
        defaultValue={defaultValue}
        {...props}
      />
      {error && (
        <div className="field-error" role="alert">
          <Icon icon="info-circle" size="sm" />
          <span>{error}</span>
        </div>
      )}
    </div>
  )
}
